/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

import _ from "lodash";

import NamespaceEvents from "../../util/NamespaceEvents";

var KeepaliveController = function (
    $rootScope,
    $scope,
    $modal,
    Idle,
    Keepalive,
    ActivityFactory,
    $document
) {
    var deregistrationFunctions = [];

    function initKeepalive() {
        if ($rootScope.keepaliveInited) {
            // disallow multiple keepalive event listeners
        } else {
            configureKeepaliveListeners();
            // PW-17235 handling the case where legacy is going to deep link into withdrawal request screen
            // the requirement is to have no idle timer
            if (!$rootScope.iframe) {
                Idle.watch();
            }
            Keepalive.start();
            $rootScope.keepaliveInited = true;
        }
    }
    function clearKeepalive() {
        clearKeepaliveListeners();
        Idle.unwatch();
        Keepalive.stop();
        $rootScope.keepaliveInited = false;
    }

    function configureKeepaliveListeners() {
        var modalInstance,
            modalOpening = false;
        var interruptEvents = NamespaceEvents(
            _.get(
                Idle._options(),
                "interrupt",
                "mousemove keydown DOMMouseScroll mousewheel mousedown"
            ),
            "keepalive"
        );

        deregistrationFunctions.push(
            $scope.$on("IdleStart", function () {
                // Keepalive.stop();
                doWhenIdle(showKeepaliveWarningModal);
            })
        );

        function doWhenIdle(callback) {
            ActivityFactory().then(function (xhr) {
                if (_.get(xhr, "data.isAuthenticated") && _.get(xhr, "data.isIdle")) {
                    callback();
                } else {
                    // PW-17235 handling the case where legacy is going to deep link into withdrawal request screen
                    // the requirement is to have no idle timer
                    if (!$rootScope.iframe) {
                        Idle.watch();
                    }
                    watchForUserActivity();
                }
            }, callback);
        }

        function resumeKeepalive() {
            //  Keepalive.start();
            Keepalive.ping();
        }

        function watchForUserActivity() {
            $document.off(interruptEvents).on(interruptEvents, function (e) {
                resumeKeepalive();
                $document.off(interruptEvents);
            });
            deregistrationFunctions.push(_.partial($document.off, interruptEvents));
        }

        function showKeepaliveWarningModal() {
            watchForUserActivity();
            if (!modalInstance && !modalOpening) {
                modalOpening = true;
                modalInstance = $modal.open({
                    template: `
                    <div class="modal-header">
                        <h4 class="modal-title">Your session will expire soon</h4>
                    </div>
                    <div class="modal-body">
                        <p>
                            You only have
                            <span ng-if="idleRemaining.minutes > 0">{{idleRemaining.minutes}} minutes and</span>
                            {{idleRemaining.seconds}} seconds until you are automatically logged out.
                        </p>
                        <p>Press any key or move your mouse to resume your session.</p>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-link" ng-click="$close('back');">Dismiss</button>
                    </div>
                    `,
                    scope: $rootScope
                });
                modalInstance.opened.then(function () {
                    modalOpening = false;
                });
                modalInstance.result.then(
                    function () {
                        // closed
                        resumeKeepalive();
                        modalInstance = null;
                    },
                    function () {
                        // dismissed
                        modalInstance = null;
                    }
                );
            }
        }

        function closeModal() {
            if (modalInstance && _.isFunction(modalInstance.close)) {
                modalInstance.close("back");
            }
        }
        function dismissModal() {
            if (modalInstance && _.isFunction(modalInstance.dismiss)) {
                modalInstance.dismiss("back");
            }
        }

        deregistrationFunctions.push(
            $scope.$on("IdleWarn", function (e, countdown) {
                var remaining = { totalSeconds: countdown };
                remaining.minutes = Math.floor(countdown / 60);
                remaining.seconds = countdown - remaining.minutes * 60;

                $rootScope.idleRemaining = remaining;
                $rootScope.$apply();
            })
        );

        deregistrationFunctions.push(
            $scope.$on("IdleEnd", function () {
                dismissModal();
            })
        );

        deregistrationFunctions.push(
            $scope.$on("IdleTimeout", function (e) {
                //Check for activity one last time
                doWhenIdle(function logout() {
                    dismissModal();
                    Idle.unwatch();
                    $rootScope.isIncompleteModalExist = true;
                    $scope.logout(e);
                });
            })
        );
    }

    function clearKeepaliveListeners() {
        _.each(deregistrationFunctions, function (func) {
            func();
        });
        deregistrationFunctions = [];
    }

    return {
        init: initKeepalive,
        clear: clearKeepalive
    };
};

KeepaliveController.$inject = [
    "$rootScope",
    "$scope",
    "$modal",
    "Idle",
    "Keepalive",
    "ActivityFactory",
    "$document"
];
export default KeepaliveController;
